export default class ImprintController {
	/* @ngInject */
    constructor($scope, $ionicLoading, ApiImprint) {
        this.$scope = $scope;
        this.ApiImprint = ApiImprint;
        this.$ionicLoading = $ionicLoading;
        this.data = {};
    }

    init() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });

        this.ApiImprint.getImprintDetails().then((res) => {
            if (typeof res != 'undefined') {
                this.data = res.data;
                this.$ionicLoading.hide();
            } else {
                this.$ionicLoading.hide();
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/components/imprint/imprint.controller.js
 **/